import { render, staticRenderFns } from "./orderPrePaymentDetails.vue?vue&type=template&id=1ae8d3b8&"
import script from "./orderPrePaymentDetails.vue?vue&type=script&lang=js&"
export * from "./orderPrePaymentDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports